import { useQuery } from "@tanstack/react-query"
import { instagramIntegrationsQuery } from "modules/settings/lib/instagram/instagramIntegrationsQuery"

export function useInstagramIntegrationsQuery(
  ...args: Parameters<typeof instagramIntegrationsQuery>
) {
  return useQuery(instagramIntegrationsQuery(...args))
}
